<div *ngFor="let item of doc" class="item-page-break">


  <ng-container *ngIf="item._source.docTyp.id == '2'">
  <h3>Doctyp: Person (id: {{item._id}})</h3>

<h1>

      <ng-container *ngIf="item._source && item._source['2_pnamefamily']">
        <span>{{item._source['2_pnamefamily']}}</span>
      </ng-container>

      <ng-container
        *ngIf="item._source && item._source['2_pnamefamily'] && item._source['2_pnamefirst']">,
      </ng-container>

      <ng-container *ngIf="item._source && item._source['2_pnamefirst']">
        <span>{{item._source['2_pnamefirst']}}</span>
      </ng-container>

      <ng-container
        *ngIf="item._source && item._source['2_pnamecomponent']">
        <span> {{item._source['2_pnamecomponent']}}</span>
      </ng-container>

      <ng-container *ngIf="item._source && item._source['2_ptitledesign']">
        <span>, {{item._source['2_ptitledesign'].content}}</span>
      </ng-container>

      <ng-container *ngIf="item._source && item._source['2_pnametype']">
        <ng-container
          *ngFor="let item2 of item._source['2_pnametype']; let
        isLast=last">
          ({{item2.content}})
        </ng-container>
      </ng-container>

      <ng-container *ngIf="item._source && item._source['docTyp']['id'] == '3'">
        <ng-container *ngIf="item._source && item._source['3_stadt']">
          {{ item._source['3_stadt'].content}}
        </ng-container>
      </ng-container>

      <ng-container
        *ngIf="item._source && item._source['docTyp']['id'] == '4'">
        <ng-container *ngIf="item._source['4_obj_titel0']">
          {{item._source['4_obj_titel0']}}
        </ng-container>
      </ng-container>

      <ng-container
        *ngIf="item._source && item._source['docTyp']['id'] == '5'">
        <ng-container *ngIf="item._source && item._source['5_erg4stadt']">
          {{ item._source['5_erg4stadt'].content}}
        </ng-container>

        <ng-container *ngIf="item._source && item._source['5_erg4wahl']">
          <span> &#8211; </span>{{ item._source['5_erg4wahl'].content}}
        </ng-container>
      </ng-container>
      
      
</h1>

  <table>
    <tr><td>Lebensdaten:</td>
      <td>
        <ng-container *ngIf="item._source['2_Ereignisse']">
          
          <ng-container *ngFor="let event of item._source['2_Ereignisse'] | keyvalue: asIsOrder; let first = first; let last = last">
              {{event.value.peventsub[0].content }}
          
              <span *ngIf="event.value.pstdatesub">{{
                getFormattedDate(event.value.pstdatesub) }}
              </span>

              <span *ngIf="event.value.pstdatesub && event.value.penddatesub">
                -
              </span>

              <span *ngIf="event.value.penddatesub">{{
                getFormattedDate(event.value.penddatesub)}}
              </span>

            

              <span *ngIf="event.value.pendverificationsub">{{
                event.value.pendverificationsub[0].content
                }}</span>
              <span *ngIf="event.value.psubjectsub"> ({{
                event.value.psubjectsub}})</span>
                <br>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="!item._source['2_Ereignisse']">
          Kein Inhalt vorhanden
        </ng-container>
      </td>
    </tr>


    <tr><td>Geschlecht:</td><td>{{item._source['2_pgender'].content || 'Kein Inhalt vorhanden'}}</td></tr>
    <tr><td>Genannter Beruf(e):</td><td>
      <ng-container *ngIf="item._source['2_personberuf']?.length > 0; else noContent">
        <ng-container *ngFor="let beruf of item._source['2_personberuf']">
          {{beruf.content}}
        </ng-container>
      </ng-container>
      <ng-template #noContent>
        Kein Inhalt vorhanden
      </ng-template>
    </td></tr>
    <tr><td>Ratsmandate:</td><td>
   
      <ul *ngIf="item._source['2_pprojectclass']?.length > 0; else noContent">
        <li *ngFor="let mandate of item._source['2_pprojectclass']">
          <div class="row">
            <div class="fixed-col">
              Stadt
            </div>
            <div class="col">
              <ng-container *ngFor="let city of mandate.wahlstadt; let isLast=last">
                {{city.content}}
                <span *ngIf="!isLast">;</span>
              </ng-container>
            </div>
          </div>
          <div class="row">
            <div class="fixed-col">
              Wahl
            </div>
            <div class="col">
              <ng-container *ngFor="let election of mandate.legislatur; let isLast=last">
                {{election.content}} ({{getFormattedDate(election.LmAdd.electiondate)}})
                <span *ngIf="!isLast">;</span>
              </ng-container>
            </div>
          </div>
          <div class="row">
            <div class="fixed-col">
              Partei
            </div>
            <div class="col">
              <ng-container *ngFor="let party of mandate.wahlpartei; let isLast=last">
                {{party.content}}
                <span *ngIf="!isLast">;</span>
              </ng-container>
            </div>
          </div>
          <div class="row">
            <div class="fixed-col">
              nachgerückt am
            </div>
            <div class="col">
              {{getFormattedDate(mandate.neuesmitgliedseit)}}
            </div>
          </div>
          <div class="row">
            <div class="fixed-col">
              Nachgerückt für
            </div>
            <div class="col">
              <ng-container *ngFor="let member of mandate.nachgeruecktfuer; let isLast=last">
                <a (click)="toDocument(member.LmAdd.persdok)" href="{{environment.wordpressPageUrl}}/#/document/{{member.LmAdd.persdok}}" target="_self">{{member.content}}</a>
                <span *ngIf="!isLast">;</span>
              </ng-container>
            </div>
          </div>
          <div class="row">
            <div class="fixed-col">
              ausgeschieden am
            </div>
            <div class="col">
              {{getFormattedDate(mandate.mitgliedbis)}}
            </div>
          </div>
        </li>
      </ul>

      
      <ng-template #noContent>
        Kein Inhalt vorhanden
      </ng-template>
    </td></tr>
    <tr><td>Höhere Ämter:</td><td>{{item._source['2_phoehere_aemter']?.content || 'Kein Inhalt vorhanden'}}</td></tr>
    <tr><td>Externe Nachweise:</td><td>{{item._source['2_pexternenachweise']?.content || 'Kein Inhalt vorhanden'}}</td></tr>
    <tr><td>Quellen:</td><td>{{item._source['2_pquellen']?.content || 'Kein Inhalt vorhanden'}}</td></tr>
    <tr><td>Bearbeitervermerk:</td><td>{{item._source['2_pbearbeitervermerk']?.content || 'Kein Inhalt vorhanden'}}</td></tr>
    <tr><td>Letzte Bearbeitung:</td><td>
      <ng-container *ngIf="item._source && item._source['timelastchg']">
        {{item._source['timelastchg']}}
      </ng-container>
    </td></tr>

    

  </table>



</ng-container>


<ng-container *ngIf="item._source.docTyp.id == '3'">
  <h3>Doctyp: Stadt (id: 3)</h3>
  <table>
    <tr><td>Stadt:</td><td></td></tr>
    <tr><td>Beschreibung:</td><td></td></tr>
    <tr><td>Literatur - red. Kommentar:</td><td></td></tr>
    <tr><td>Literatur - Quellengrundlage:</td><td></td></tr>
    <tr><td>Wahlen - Wahlergebnis:</td><td></td></tr>
    <tr><td>Wahlen - Stadträte:</td><td></td></tr>
    <tr><td>Ämter:</td><td></td></tr>
    <tr><td>Quellen:</td><td></td></tr>
    <tr><td>Bearbeitervermerk:</td><td></td></tr>
  </table>
</ng-container>


  <ng-container *ngIf="item._source.docTyp.id == '4'">
  <h3>Doctyp: Protokolle/Bilder (id: 4)</h3>

  <table>
    <tr><td>Titel:</td><td></td></tr>
    <tr><td>Bildunterschrift:</td><td></td></tr>
    <tr><td>Urheber/Fotograf:</td><td></td></tr>
    <tr><td>Motivkategorie:</td><td></td></tr>
    <tr><td>Link zum Bild:</td><td></td></tr>
    <tr><td>Aufnahmeort:</td><td></td></tr>
    <tr><td>Link zum Stadtdokument:</td><td></td></tr>
    <tr><td>Aufnahmedatum:</td><td></td></tr>
    <tr><td>Rechteinhaber:</td><td></td></tr>
    <tr><td>Lizenzen:</td><td></td></tr>
    <tr><td>Sachindex:</td><td></td></tr>
    <tr><td>Verzeichnete Personen:</td><td></td></tr>
    <tr><td>Anmerkung:</td><td></td></tr>
    <tr><td>Beschreibung:</td><td></td></tr>
    <tr><td>Nachweis - Aufbewahrungsort:</td><td></td></tr>
    <tr><td>Nachweis - Signatur/Inventarnummer:</td><td></td></tr>
    <tr><td>Nachweis - Link:</td><td></td></tr>
  </table>
</ng-container>

  <ng-container *ngIf="item._source.docTyp.id == '5'">
  <h3>Doctyp: Wahl (id: 5)</h3>

  <table>
    <tr><td>Stadt:</td><td></td></tr>
    <tr><td>Wahldatum:</td><td></td></tr>
    <tr><td>Wahlergebnis:</td><td></td></tr>
    <tr><td>Quelle:</td><td></td></tr>
    <tr><td>Wahlberechtigte:</td><td></td></tr>
    <tr><td>Wähler insgesamt:</td><td></td></tr>
    <tr><td>Wahlbeteiligung (in %):</td><td></td></tr>
    <tr><td>Ungültige Stimmen:</td><td></td></tr>
    <tr><td>Stimmenanteile Parteien:</td><td></td></tr>
    <tr><td>Ratsmitglieder (Anzahl):</td><td></td></tr>
    <tr><td>Ratsmitglieder:</td><td></td></tr>
  </table>
</ng-container>



<ng-container *ngIf="this.doc && this.doc['timelastchg']">
  <div class="row zeile">
    <div class="fixed-col">
      <strong>letzte Bearbeitung</strong>
    </div>
    <div class="col">
      {{getFormattedDate(this.doc['timelastchg'])}}
    </div>
  </div>
</ng-container>


</div>
